import { Component } from '@angular/core';
import { membersuiteSubscriptionFeeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Subscription Fees') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitesubscriptionfee-form',
    templateUrl: './membersuitesubscriptionfee.form.component.html'
})
export class membersuiteSubscriptionFeeFormComponent extends BaseFormComponent {
    public record!: membersuiteSubscriptionFeeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

